// Test/Local variables - used when REACT_APP_USE_TEST_VARIABLES=true
export const TestVariables = {
  COGNITO_USER_POOL_ID: 'us-east-2_OzcM4eA0W',
  COGNITO_CLIENT_ID: '5q9uvefuls4n8mi1srfkfk5mh0',
  IDENTITY_POOL_ID: 'us-east-2:5b83cc1c-b9b3-4a56-a449-216294817b90',
  API_ENDPOINT: 'https://4cpttcnom1.execute-api.us-east-2.amazonaws.com/prod',
  JOBS_API_ENDPOINT: 'https://7i1g6idfp9.execute-api.us-east-2.amazonaws.com/prod',
  REGION: 'us-east-2',
  AGENT_GATEWAY_URL: 'https://chulas-agent-gateway-xbi4foc4qi.gateway.bedrock-agentcore.us-east-2.amazonaws.com/mcp',
  EMPLOYEE_API_ENDPOINT: 'https://ojm90duw2a.execute-api.us-east-2.amazonaws.com/prod',
  EMPLOYEE_USER_POOL_ID: 'us-east-2_t7WDkeAnK',
  EMPLOYEE_CLIENT_ID: '6jmd6lpfl0mo2p50lsokto7ilq',
};
